import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { CohortDto } from '@hub-la/sdk-bff-product'
import { inject } from 'inversify'
import { Envs } from '../envs'

export class GetCohorts {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<CohortDto[]> {
    const response = await this.httpClient.request({
      method: HttpMethod.GET,
      url: `${Envs.BFF_PRODUCT_URL}/products/${id}/cohorts`,
      params: {
        page: 1,
        pageSize: 99,
      },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.items
    }

    throw new Error('Error getting cohorts')
  }
}
